module.exports = __webpack_public_path__ + "img/bg-ocupado.8388760a.png";